var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_187561",
    "data-name": "Group 187561",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.468,
    height: 27.468,
    viewBox: "0 0 27.468 27.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187479",
    "data-name": "Group 187479"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147040",
    "data-name": "Rectangle 147040",
    width: 27.468,
    height: 27.468,
    rx: 4,
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37657",
    "data-name": "Path 37657",
    d: "M9.141,13.282a.361.361,0,0,0,.233-.089c.143-.137,3.908-3.385,3.908-6.761A4.294,4.294,0,0,0,9.141,2,4.294,4.294,0,0,0,5,6.432c0,3.377,3.765,6.624,3.908,6.761a.361.361,0,0,0,.233.089ZM5.753,6.432A3.513,3.513,0,0,1,9.141,2.806a3.513,3.513,0,0,1,3.388,3.626c0,2.538-2.586,5.162-3.388,5.919C8.339,11.594,5.753,8.971,5.753,6.432Z",
    transform: "translate(-5 -2)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37658",
    "data-name": "Path 37658",
    d: "M14.633,9.944A1.883,1.883,0,0,0,12.816,8,1.883,1.883,0,0,0,11,9.944a1.883,1.883,0,0,0,1.816,1.944A1.883,1.883,0,0,0,14.633,9.944Zm-2.906,0a1.092,1.092,0,1,1,1.09,1.166A1.13,1.13,0,0,1,11.727,9.944Z",
    transform: "translate(-8.675 -5.535)",
    fill: "#61277f",
    stroke: "#61277f",
    strokeWidth: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.153658701eb815ebd4e1e4b93ed460bd.svg";
export { ForwardRef as ReactComponent };